module.exports = __webpack_public_path__ + "static/media/headers.d61f31e7.jpg";